module.exports = __webpack_public_path__ + "static/media/pencil-alt.29f32609.svg";